<template>
    <div id="layout-config">
        <a id="layout-config-button" class="layout-config-button" @click="onConfigButtonClick($event)">
            <i class="pi pi-cog"></i>
        </a>
        <div class="layout-config" :class="{ 'layout-config-active': configActive }" @click="onConfigClick">
            <!-- <h5>Menu Type</h5>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="static" v-model="d_menuMode" id="mode1" @change="changeMenuMode('static')"></RadioButton>
                <label for="mode1">Static</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="overlay" v-model="d_menuMode" id="mode2" @change="changeMenuMode('overlay')"></RadioButton>
                <label for="mode2">Overlay</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="slim" v-model="d_menuMode" id="mode3" @change="changeMenuMode('slim')"></RadioButton>
                <label for="mode3">Slim</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="horizontal" v-model="d_menuMode" id="mode4" @change="changeMenuMode('horizontal')"></RadioButton>
                <label for="mode4">Horizontal</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="menuMode" value="sidebar" v-model="d_menuMode" id="mode5" @change="changeMenuMode('sidebar')"></RadioButton>
                <label for="mode5">Sidebar</label>
            </div>
            <hr /> -->

            <h5>Color Scheme</h5>
            <div class="field-radiobutton">
                <RadioButton name="colorScheme" value="light" v-model="d_colorScheme" id="theme2" @change="changeColorScheme('light')"></RadioButton>
                <label for="theme2">Light</label>
            </div>
            <div class="field-radiobutton">
                <RadioButton name="colorScheme" value="dark" v-model="d_colorScheme" id="theme1" @change="changeColorScheme('dark')"></RadioButton>
                <label for="theme1">Dark</label>
            </div>
            <hr />

            <div v-if="role_user == 'superadmin'">
                <h5>Membership Referral</h5>
                <Dropdown class="col-12" v-model="membership_referral" :options="options_setting" optionLabel="text" optionValue="value" @change="updateSetting()"/>
                <hr />
            </div>
            

            <!-- <h5>Ripple Effect</h5>
            <InputSwitch :modelValue="rippleActive" @update:modelValue="onRippleChange"  />
            <hr /> -->

            <!-- <h5>Layouts</h5>
            <div class="layout-themes">
                <div v-for="t in themes" :key="t.name">
                    <a style="cursor: pointer" @click="changeTheme(t.name)" :title="t.name" :style="{ 'background-color': t.color }">
                        <i class="pi pi-check" v-if="theme === t.name"></i>
                    </a>
                </div>
            </div>
            <hr />

            <h5>Themes</h5>
            <div class="layout-themes">
                <div v-for="theme in componentThemes" :key="theme.name">
                    <a style="cursor: pointer" @click="changeComponentTheme(theme.name)" :title="theme.name" :style="{ 'background-color': theme.color }">
                        <i class="pi pi-check" v-if="componentTheme === theme.name"></i>
                    </a>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppConfig',
    emits: ['config-button-click', 'config-click', 'change-color-scheme', 'change-menu-theme', 'change-component-theme', 'change-menu-mode'],
    props: {
        configActive: {
            type: Boolean,
            default: null,
        },
        configClick: {
            type: Boolean,
            default: null,
        },
        colorScheme: String,
        theme: String,
        componentTheme: String,
        menuMode: String
    },
    data() {
        return {
            themes: [
                {name: 'blue', color: '#0F8BFD'},
                {name: 'green', color: '#0BD18A'},
                {name: 'magenta', color: '#EC4DBC'},
                {name: 'orange', color: '#FD9214'},
                {name: 'purple', color: '#873EFE'},
                {name: 'red', color: '#FC6161'},
                {name: 'teal', color: '#00D0DE'},
                {name: 'yellow', color: '#EEE500'}
            ],
            componentThemes: [
                {name: 'blue', color: '#0F8BFD'},
                {name: 'green', color: '#0BD18A'},
                {name: 'magenta', color: '#EC4DBC'},
                {name: 'orange', color: '#FD9214'},
                {name: 'purple', color: '#873EFE'},
                {name: 'red', color: '#FC6161'},
                {name: 'teal', color: '#00D0DE'},
                {name: 'yellow', color: '#EEE500'}
            ],
            d_colorScheme: this.colorScheme,
            d_menuMode: this.menuMode,
            membership_referral: null,
            options_setting: [
                {text: '1 month', value: 1},
                {text: '2 month', value: 2},
                {text: '3 month', value: 3},
                {text: '4 month', value: 4},
                {text: '5 month', value: 5},
                {text: '6 month', value: 6},
                {text: '7 month', value: 7},
                {text: '8 month', value: 8},
                {text: '9 month', value: 9},
                {text: '10 month', value: 10},
                {text: '11 month', value: 11},
                {text: '12 month', value: 12},
            ], 
        };
    },
    computed: {
        rippleActive() {
            return this.$primevue.config.ripple;
        },
        role_user(){
			return this.$store.state.user_role
		},
    },
    mounted(){
        this.get_setting()
    },
    methods: {
        async get_setting() {
            let vm = this
            let setting = await vm.$axios.post('/setting/list');
            console.log(setting, 'ini seting');
            
            vm.membership_referral = setting.data.data[0].qty
        },
        updateSetting(){
            let vm = this
            vm.$axios
                .post('/setting/update', {
                    id: '1',
                    qty: vm.membership_referral,
                    uom: 'month'
                })
                .then((res) => {
                    // console.log(res.data);
                    if (res.data.status == 200) {
                        if (res.data.message == 'success') {
                            vm.display = false;
                            vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Update Setting Membership Referral', life: 3000 });
                        } else {
                            vm.display = false;
                            vm.$toast.add({ severity: 'warn', summary: 'Konfirmasi', detail: res.data.message, life: 3000 });
                        }
                    } else {
                        vm.display = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    vm.display = false;
                    vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Terjadi kesalahan pada server', life: 3000 });
                });
        },
        changeTheme(theme) {
            this.$emit('change-menu-theme', theme);
        },
        changeComponentTheme(theme) {
            this.$emit('change-component-theme', theme);
        },
        changeColorScheme(scheme) {
            this.$emit('change-color-scheme', scheme);
        },
        onConfigButtonClick(event) {
            this.$emit('config-button-click', event);
            event.preventDefault();
        },
        onConfigClick(event) {
            this.$emit('config-click', event);
        },
        changeMenuMode(mode) {
            this.$emit('change-menu-mode', mode);
        },
        onRippleChange(value) {
            this.$primevue.config.ripple = value;
        }
    }
};
</script>
